class FormCheck {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {
    const radioButtons = document.querySelectorAll('input[type="radio"]');
    const formElements = document.querySelector('.form-elements');
    const receptionMessage = document.querySelector('.reception__message');
    receptionMessage.style.display = "none";

    if($('.error').length >= 1) {
      $('.form-elements').removeClass('disable');
    }
    

    radioButtons.forEach(radioButton => {
      radioButton.addEventListener('change', function() {
        if (radioButton.value === 'true') {
          formElements.classList.remove('disable');
          receptionMessage.style.display = "none";
        } else if (radioButton.value === 'false') {
          formElements.classList.add('disable');
          receptionMessage.style.display = "block";
        }
      });
    });
  }
}
